module.exports = __webpack_public_path__ + "static/media/ocbc.5f62a9aa.png";